import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import swal from 'sweetalert2';

declare var $: any;
declare var pnCheckoutShared: any;
@Component({
  selector: 'app-e-mandate',
  templateUrl: './e-mandate.component.html',
  styleUrl: './e-mandate.component.scss'
})
export class EMandateComponent {
  private scripts: HTMLScriptElement[] = [];
  isLoading = false;

  public constructor(private router: Router, private finzyService: FinzyService, private spinner: NgxSpinnerService) { }

  async ngOnInit() {
    this.spinner.show();
    try {
      var res = await lastValueFrom(this.finzyService.checkENach());
      if (res['data']) {
        this.spinner.hide();
        return this.router.navigateByUrl("/assist-journey/f/payment");
      }
    } catch (error) {
      this.spinner.hide();
    }

    this.spinner.hide()
    this.loadScriptsSequentially([
      'https://www.paynimo.com/Paynimocheckout/client/lib/jquery.min.js',
      'https://www.paynimo.com/Paynimocheckout/server/lib/checkout.js'
    ]).then(() => {
      console.log('Paynimo scripts loaded');
    });
  }

  ngOnDestroy(): void {
    this.scripts.forEach(script => document.body.removeChild(script));
  }

  private loadScriptsSequentially(urls: string[]): Promise<void> {
    return urls.reduce((prev, url) => {
      return prev.then(() => new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = false;
        script.onload = () => {
          this.scripts.push(script);
          resolve();
        };
        script.onerror = reject;
        document.body.appendChild(script);
      }));
    }, Promise.resolve());
  }

  handleResponse = (res: any): void => {
    console.log('Payment Response:', res);

    const status = res?.paymentMethod?.paymentTransaction?.statusCode;

    if (status === '0300') {
      alert('Payment Successful!');
    } else if (status === '0398') {
      alert('Payment Initiated!');
    } else {
      alert('Payment Failed or Aborted!');
    }

    console.log('Redirecting based on returnUrl...', res?.consumerData?.returnUrl);

    // const returnUrl = res?.consumerData?.returnUrl || '/';
    // if (returnUrl.startsWith('http')) {
    //   window.location.href = returnUrl;
    // } else {
    //   this.router.navigateByUrl(returnUrl);
    // }
  };

  async initiatePayment() {
    this.isLoading = true;

    try {

      // const configJson: any = await this.http
      //   .get('https://your-backend.com/api/enach/config')
      //   .toPromise();

      var res = await lastValueFrom(this.finzyService.initiateENach());
      if (res['error']) {
        swal.fire('Error', 'Failed to initiate eNACH. Please try again.');
      }

      var configJson: any = res['data'];
      if (typeof configJson === 'string') {
        try {
          configJson = JSON.parse(configJson);
        } catch (err) {
          console.error('Invalid config JSON:', err);
          return;
        }
      }

      configJson.consumerData.responseHandler = this.handleResponse;
      configJson.consumerData.returnUrl = configJson.consumerData.returnUrl.replace('update-enach', 'update-enach/' + MemoryStorageService.getItem('lenderApplId'));

      console.log('Received configJson from backend:', configJson);

      if (window && (window as any).$ && (window as any).$.pnCheckout) {
        (window as any).$.pnCheckout(configJson);

        if (configJson.features.enableNewWindowFlow) {
          pnCheckoutShared.openNewWindow();
        }
      } else {
        console.error('Paynimo checkout.js not loaded yet.');
        alert('Payment SDK not loaded. Please refresh and try again.');
      }
    } catch (err) {
      console.error('Error fetching config from backend:', err);
      alert('Failed to initiate payment. Please try again.');
    } finally {
      this.isLoading = false;
    }
  }
}
